import React, { useEffect, useState } from 'react';
import { WelcomeLogo } from '@components/molecules/WelcomeLogo';
import { LoginForm } from '@components/molecules/LoginForm';
import { MobileContainer } from '@components/organism/MobileContainer';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Space } from '@components/atoms/Space';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './Login.module.css';
import { splashState } from 'src/splashState';
import { useData } from '@hooks/useData';

export const Login: React.FC = () => {
    const [isLoading, setIsLoading] = useState(!splashState.shown);
    const [showLogo, setShowLogo] = useState(!splashState.shown);
    const { t } = useTranslation();
    const { allSettings } = useData();

    const translations = {
        login: t('login.login'),
        benefits: t('login.benefits'),
        terms1: t('login.terms1'),
        terms2: t('login.terms2'),
        terms3: t('login.terms3'),
        termsConditions: t('login.terms-conditions'),
        privacyPolicy: t('login.privacy-policy'),
        financingLogo: t('login.financing-logo'),
    };

    useEffect(() => {
        if (!splashState.shown) {
            splashState.shown = true;

            const timer = setTimeout(() => setIsLoading(false), 2000);
            return () => clearTimeout(timer);
        } else {
            setIsLoading(false);
            setShowLogo(false);
        }
    }, []);

    useEffect(() => {
        if (!isLoading) {
            const fadeTimer = setTimeout(() => setShowLogo(false), 800);
            return () => clearTimeout(fadeTimer);
        }
    }, [isLoading]);

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            <MobileContainer>
                <div className="w-100">
                    <Space spaceBreakpoints={{ xs: { space: 50 } }} />
                    <Typography fontWeight="800" fontSize="24" align="center">
                        {translations.login}
                    </Typography>
                    <Space spaceBreakpoints={{ xs: { space: 15 } }} />
                    <Typography fontWeight="400" fontSize="16" align="center" color="muted">
                        {translations.benefits}
                    </Typography>
                    <Space spaceBreakpoints={{ xs: { space: 50 } }} />
                    <LoginForm />
                    <Space spaceBreakpoints={{ xs: { space: 100 } }} />
                    <Typography fontWeight="400" fontSize="14" align="center" color="muted">
                        <>
                            <div dangerouslySetInnerHTML={{ __html: allSettings?.data?.copyright ?? '' }} />
                        </>
                    </Typography>
                    <Typography color="muted" fontSize="14" align="center">
                        <>
                            {translations.terms1}
                            <Link to="/terms-and-conditions" className={styles.no_underline}>
                                <Typography tagVariant={TypographyTagVariants.span} color="primary">
                                    {` ${translations.termsConditions} `}
                                </Typography>
                            </Link>

                            {translations.terms2}
                            <Link to="/privacy-policy" className={styles.no_underline}>
                                <Typography tagVariant={TypographyTagVariants.span} color="primary">
                                    {` ${translations.privacyPolicy} `}
                                </Typography>
                            </Link>
                            {translations.terms3}
                        </>
                    </Typography>
                    <Space spaceBreakpoints={{ xs: { space: 50 } }} />
                    <div className="d-flex justify-content-center align-items-center">
                        <img
                            className={styles.logo_img}
                            src={allSettings?.data?.financingLogo}
                            alt={translations.financingLogo}
                        />
                    </div>
                </div>
            </MobileContainer>

            {showLogo && (
                <div style={{ position: 'absolute', inset: 0, zIndex: 9999 }}>
                    <WelcomeLogo isVisible={isLoading} />
                </div>
            )}
        </div>
    );
};
